import { css } from '@emotion/react';
import { Layout } from 'antd';
import { type ReactNode } from 'react';
import tw from 'twin.macro';

/**
 *  - 약관 작성 필수
 *    - https://dalock.atlassian.net/wiki/spaces/KB/folder/967933964?atlOrigin=eyJpIjoiYTczNDM4Y2M1MTBlNGMxNzg2MmFiN2NlYWQxMjMyOTgiLCJwIjoiYyJ9
 *  - 약관 내용 > 요소 검사 > div.ak-renderer-document 안에 포함된 모든 element 복사 후 html 파일로 작성
 *  - S3 업로드 (REACT_APP_POLICY_S3_DOMAIN 환경변수 참고)
 *  - 새로운 유형의 약관이 생긴다면 Route.tsx / externalApi.getPolicyFromS3 신규 유형 타입과 파일 추가 필요
 *  - 이미 올라간 유형의 새로운 버전을 이력 형태로 변경해야 한다면 추가 개발 필요
 */
interface Props {
  children?: ReactNode;
}

const PolicyLayout = ({ children }: Props) => {
  return (
    <Layout css={layoutStyle}>
      <Layout.Content>{children}</Layout.Content>
    </Layout>
  );
};

export default PolicyLayout;

const layoutStyle = css`
  ${tw`w-full h-[max-content] p-[100px] bg-[#fff] text-[16px] leading-[25px]`}

  .ak-renderer-document {
    h1 {
      font-size: 36px;
      margin-top: 40px;
      margin-bottom: 10px;
    }
    h2 {
      font-size: 28px;
      margin-top: 40px;
      margin-bottom: 10px;
    }
    h3 {
      font-size: 20px;
      margin-top: 70px;
      margin-bottom: 15px;
    }

    p {
      width: 100%;
    }

    a {
      color: #1890ff;
      text-decoration: none;
      background-color: transparent;
      outline: none;
      cursor: pointer;
      transition: color 0.3s;
      -webkit-text-decoration-skip: objects;
    }

    ol,
    ul {
      padding-left: 1.4em;
      &[data-indent-level='1'] li {
        text-indent: 0.2em;
        list-style-type: decimal;
      }

      &[data-indent-level='2'] li {
        text-indent: 0.2em;
        list-style-type: lower-alpha;
      }
    }

    .ak-renderer-tableHeader-sortable-column p {
      margin-bottom: 0 !important;
      padding-top: 10px;
      padding-bottom: 10px;
    }

    table {
      width: 100%;
      text-align: center;
      margin: 10px 0;
      border: 1px solid #e6e6e6;
      tr {
        border-top: 1px solid #e6e6e6;
        border-bottom: 1px solid #e6e6e6;
        td,
        th {
          border-right: 1px solid #e6e6e6;
          border-left: 1px solid #e6e6e6;
        }
        td {
          padding: 20px 5px;
          ul {
            list-style-type: none !important;
          }
        }
        td[colorname='Light gray'] {
          background-color: #f4f5f7 !important;
        }
      }
    }
  }
`;
